"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgToolboxOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M26 8V3.94l-.59-.27A24.5 24.5 0 0016 2a24.5 24.5 0 00-9.4 1.67l-.6.27V8H2v19h28V8zM8 5.27A24.21 24.21 0 0116 4a24.21 24.21 0 018 1.28V8H8zM28 10v5H4v-5zM4 25v-8h11v2h2v-2h11v8z" })));
}
exports.default = SvgToolboxOutline;
//# sourceMappingURL=ToolboxOutline.js.map